const triggerBtnReservation = () => {
  const buttons = document.querySelectorAll('.btn-reservation') || null;
  if (buttons) {
    buttons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const url = btn.getAttribute('data-url');
        window.location= url;
      })
    })
  }
}

const init = () => {
  triggerBtnReservation();
}

init();